import { ArticleCard, ArticleCardData } from "@baseComponents/ArticleCard";
import { useMediaQueryBreakpoint } from "@hooks";

import {
  ProjectsSeeAlsoContainer,
  ProjectsSeeAlsoHeader,
  ProjectsSeeAlsoSubheader,
} from "./ArticlesSeeAlso.styled";

interface ArticlesSeeAlsoProps {
  articles: ArticleCardData[];
  sectionHeader: string;
  sectionSubheader: string;
  className?: string;
}

export const ArticlesSeeAlso = ({
  articles,
  sectionHeader,
  sectionSubheader,
  className,
}: ArticlesSeeAlsoProps) => {
  const { isDesktop, tabletThreshold, desktopThreshold } =
    useMediaQueryBreakpoint();

  const imageSizes = `(min-width: ${desktopThreshold}px) 30vw, (min-width: ${tabletThreshold}px) 50vw, 100vw`;

  return (
    <div className={`flex flex-col gap-4 ${className}`}>
      <div>
        <ProjectsSeeAlsoHeader>{sectionHeader}</ProjectsSeeAlsoHeader>

        <ProjectsSeeAlsoSubheader>{sectionSubheader}</ProjectsSeeAlsoSubheader>
      </div>

      <ProjectsSeeAlsoContainer>
        {articles[0] && (
          <ArticleCard
            size={"small"}
            {...articles[0]}
            nextImageSizes={imageSizes}
          />
        )}

        {articles[1] && (
          <ArticleCard
            size={"small"}
            {...articles[1]}
            nextImageSizes={imageSizes}
          />
        )}

        {isDesktop && articles[2] && (
          <ArticleCard
            size={"small"}
            {...articles[2]}
            nextImageSizes={imageSizes}
          />
        )}
      </ProjectsSeeAlsoContainer>
    </div>
  );
};
